<template>
  <!-- Rudimentary responsive page container that lives on a 12-grid -->
  <div class="tw:mx-auto tw:p-4 tw:md:p-8 tw:max-w-[1600px] tw:w-full">
    <slot />
  </div>
</template>
